module.exports = "<uib-progressbar class=\"progress-striped active\" value=\"status\" style=\"width:250px;\"></uib-progressbar>\n";